module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideImage),
      expression: "!hideImage"
    }],
    staticClass: "logo__img",
    style: ({
      height: 100,
      width: 100
    }),
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "Nadespots logo"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [(!_vm.noHeader) ? _c('h1', [_vm._v("\n      Nade"), _c('em', [_vm._v("spots")])]) : _c('div', {
    staticClass: "logo__title"
  }, [_vm._v("\n      Nade"), _c('em', [_vm._v("spots")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c21c46a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 720
// module chunks = 1